enum AiImageStyle {
    DEFAULT = 'default',
    NATURAL = 'natural',
    VIVID = 'vivid',
}

export default AiImageStyle;
